'use strict';

// v1.121


import 'document-register-element';
import Draggable from 'gsap/Draggable';

import dispatcher from '../dispatcher';
import resizeStore from '../resize/resize.store';
import store from './slider.store';
import {prefixedCSSValue} from '../utils';

let idName = 'slider-id-';
let idNum = 0;


let grabbing = prefixedCSSValue('cursor', 'grabbing');
let grab = prefixedCSSValue('cursor', 'grab');



function _getId() {
  idNum++;
  return idName + idNum;
}



class Slider extends HTMLElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._slideWidth = 1;
    this._slidesActiveStart = 0;
    this._slidesActiveStartOld = false;
    this._slidesActiveCount = 1;
    this._slidesActiveCountOld = false;
    this._slidesActiveLast = [0];
    this._disabled = false;
    this._initialized = false;

    this._drag = false;

    this._update = () => {};


    this.onUpdate = e => this._onUpdate(e);
    this.resize = e => this._resize(e);
    this.subscribe = e => this._subscribe(e);
    this.animatron = e => this._animatron(e);



    this._dragParams = {
      type: 'x',
      edgeResistance: 0.6,
      dragResistance: 0,
      bounds: this,
      throwProps: true,
      dragClickables: true,
      cursor: 'none',
      snap: (val) => {
        return Math.round(val / this._slideWidth) * this._slideWidth;
      },
      callbackScope:   this,
      onDragStart:     this._onDragStart,
      // onThrowComplete: this._onThrowComplete,
      onDragEnd:       this._onDragEnd,
      onRelease:       this._onRelease,
      onDrag:          this._onUpdate,
      onThrowUpdate:   this._onUpdate
    };


  }
  connectedCallback() {
    this._id =         this.dataset.id || this.id || _getId();
    this._wrapper =    this.querySelector('.slider-wrap');
    this._slides =     Array.from(this.querySelectorAll('.slide'));
    this._speed =     +this.dataset.speed || 0.5;
    this._delay =     +this.dataset.delay || 0;
    // this._auto =       this.dataset.auto;
    // this._continuous = this.dataset.continuous;
    this._rubber =     this.dataset.rubber ? (this.dataset.rubber === 'true' ? 5 : +this.dataset.rubber) : false;
    this._noCursor =   this.dataset.noCursor;

    this._total = this._slides.length;



    if (!this._noCursor) {
      this._dragParams.cursor =    grab;
      this._dragParams.activeCursor =    grabbing;
      // this._dragParams.onPress =   this._onPress;
      // this._dragParams.onRelease = this._onReleaseCursor;
    }



    if (this._rubber) {
      let updateParams = {
        slidesBefore: [],
        slidesAfter: [],
        active: false,
        newX: 0,
        currentX: 0,
        moveX: 0,
        lastX: 0,
        speed: 0,
        smooth: 0,
        lastSmooth: 0
      };
      updateParams.raf = requestAnimationFrame(this.animatron);
      this._updateParams = updateParams;

      this._dragParams.onDrag =  this._dragParams.onThrowUpdate = this._onDragUpdate;
      this._dragParams.onPress = this._onPressRubber;
    }

    this._dragControl = this.querySelector('.slider-drag-control');

    if (this._dragControl) {
      const onUpdateControl = () => {
        const c = this._draggableControl.x / (this._dragControlWidth - this._dragControlWidthM);
        TweenLite.set(this._wrapper, {
          x: -(this._slideWidth * (this._slides.length - this._slidesActiveCount)) * c
        })
      };
      const onMainUpdate = () => {
        const c = this._wrapper._gsTransform.x / (this._slideWidth * (this._slides.length - this._slidesActiveCount));

        TweenLite.set(this._dragControl, {
          x: -(this._dragControlWidth - this._dragControlWidthM) * c
        });

        this._onUpdate();
      };

      this.onUpdate = () => onMainUpdate();
      this._dragParams.onDrag = onMainUpdate;
      this._dragParams.onThrowUpdate = onMainUpdate;

      this._draggableControl = Draggable.create(this._dragControl, {
        type: 'x',
        // edgeResistance: 0.6,
        dragResistance: 0,
        bounds: this._dragControl.parentNode,
        throwProps: true,
        cursor: grab,
        activeCursor: grabbing,
        snap: (val) => {
          const l = (this._dragControlWidth - this._dragControlWidthM) / (this._slides.length - this._slidesActiveCount);
          return l * Math.round(val / l);
        },
        onDrag: onUpdateControl,
        onThrowUpdate: onUpdateControl
      })[0];
    }


    this._timelineElement = this.querySelector('.slider-timeline');

    if (this._timelineElement) {
      const span = this._timelineElement.querySelector('span');

      const onMainUpdate = () => {
        const c = this._wrapper._gsTransform.x / (this._slideWidth * (this._slides.length - this._slidesActiveCount));

        TweenLite.set(span, {
          scaleX: -c
        });

        this._onUpdate();
      };

      this.onUpdate = () => onMainUpdate();
      this._dragParams.onDrag = onMainUpdate;
      this._dragParams.onThrowUpdate = onMainUpdate;
    }


    this._draggable = Draggable.create(this._wrapper, this._dragParams)[0];


    this.resize();
    this._getActive();
    this._removeActive();
    this._setActive();
    resizeStore.eventEmitter.subscribe(this.resize);
    store.eventEmitter.subscribe(this.subscribe);

    this._wrapper.addEventListener('dragstart', (e) => {
      e.preventDefault();
      return false;
    });
    // this._wrapper.addEventListener('touchmove', (e) => {
    //   if (!this._drag) return;
    //   e.preventDefault();
    //   return false;
    // });



    dispatcher.dispatch({
      type: 'slider-add',
      _module: 'slider.component',
      slider: {
        id:          this._id,
        activeStart: this._slidesActiveStart,
        activeCount: this._slidesActiveCount,
        total:       this._total,
        disabled:    this._disabled
      }
    });

    this._initialized = true;
  }
  disconnectedCallback() {
    if (this._updateParams) cancelAnimationFrame(this._updateParams.raf);

    resizeStore.eventEmitter.unsubscribe(this.resize);
    store.eventEmitter.unsubscribe(this.subscribe);

    dispatcher.dispatch({
      type: 'slider-remove',
      _module: 'slider.component',
      id: this._id
    });
  }

  _resize() {
    this._wrapper.style.paddingRight = '0';
    this._slideWidth = this._slides[0].offsetWidth;
    this._wrapperWidth = this._wrapper.scrollWidth;

    this._slidesActiveCountOld = this._slidesActiveCount;
    this._slidesActiveCount = Math.round(this._wrapper.clientWidth / this._slideWidth);
    this._slidesActiveCount = this._slidesActiveCount > this._total ? this._total : this._slidesActiveCount;

    this._wrapper.style.paddingRight = this._wrapperWidth - this._wrapper.clientWidth + 'px';

    if (this._slidesActiveCountOld !== this._slidesActiveCount) {
      this._dispatchChange();

      this._removeActive();
      this._setActive();
    }


    if (this._slidesActiveCount >= this._total) {
      if (!this._disabled) {
        this._draggable.disable();
        this._disabled = true;

        this._dispatchEnable();
      }
    } else {
      if (this._disabled) {
        this._draggable.enable();
        this._disabled = false;

        this._dispatchEnable();
      }
    }

    const newPos = -this._slidesActiveStart * this._slideWidth;

    TweenMax.set(this._wrapper, {
      x: newPos
    });

    if (this._dragControl) {
      this._dragControlWidthM = this._dragControl.offsetWidth;
      this._dragControlWidth = this._dragControl.parentNode.offsetWidth;

      const c = newPos / (this._slideWidth * (this._slides.length - this._slidesActiveCount));
      const x = -(this._dragControlWidth - this._dragControlWidthM) * c;

      TweenLite.set(this._dragControl, {
        x: x
      });
      // this._draggableControl.enable();
    }
  }

  _dispatchEnable() {
    if (this._initialized) {
      dispatcher.dispatch({
        type: 'slider-enable-change',
        _module: 'slider.component',
        id: this._id,
        disabled: this._disabled
      });
    }
  }

  set updateFunction(func) {
    if (typeof func === 'function') this._update = func;
  }
  // next() {}
  // prev() {}
  // changeTo() {}
  _change() {
    let slides = this._slides;

    TweenMax.to(this._wrapper, this._speed, {
      delay:           this._delay,
      x:             -(this._slidesActiveStart * this._slideWidth),
      onStartScope:    this,
      onStart:         this._removeActive,
      onCompleteScope: this,
      onComplete:      this._setActive,
      onUpdateScope:   this,
      onUpdate:        this.onUpdate
    });
  }
  _changeRubber() {
    let slides = this._slides;

    this._updateParams.slidesBefore = slides.slice(0, this._slidesActiveStart).reverse();
    this._updateParams.slidesAfter = slides.slice(this._slidesActiveStart);

    TweenMax.to(this._wrapper, this._speed, {
      delay:           this._delay,
      x:             -(this._slidesActiveStart * this._slideWidth),
      onStartScope:    this,
      onStart:         this._removeActive,
      onCompleteScope: this,
      onComplete:      this._setActive,
      onUpdateScope:   this,
      onUpdate:        this._onRubberUpdate
    });
  }

  _dispatchChange() {
    dispatcher.dispatch({
      type: 'slider-change',
      _module: 'slider.component',
      slider: {
        id:          this._id,
        activeStart: this._slidesActiveStart,
        activeCount: this._slidesActiveCount,
        total:       this._total
      }
    });
  }

  _subscribe(e) {
    if (e.type !== 'navigation-emit' || !e.items.hasOwnProperty(this._id)) return;

    this._slidesActiveStartOld = this._slidesActiveStart;
    this._slidesActiveStart = e.items[this._id].activeStart;

    if (this._slidesActiveStartOld === this._slidesActiveStart) return;

    if (this._rubber) {
      this._changeRubber();
    } else {
      this._change();
    }
  }

  _getActive() {
    let startSlide = false;

    this._slidesActiveLast = [];

    for (let i = 0; this._total > i; i++) {
      if (this._slides[i].classList.contains('active')) {
        if (!startSlide) {
          this._slidesActiveStart = i;
          startSlide = true;
        }
        this._slidesActiveLast.push(i);
      }
    }
  }
  _setActive() {
    for (let i = 0; this._slidesActiveCount > i; i++) {
      this._slides[this._slidesActiveStart + i].classList.add('active');
      this._slidesActiveLast.push(this._slidesActiveStart + i);
    }

    if (this._slidesActiveStartOld !== this._slidesActiveStart || this._slidesActiveCountOld !== this._slidesActiveCount) this._dispatchChange();
  }
  _removeActive() {
    for (let i = 0; this._slidesActiveLast.length > i; i++) {
      this._slides[this._slidesActiveLast[i]].classList.remove('active');
    }

    this._slidesActiveLast = [];
  }


  _onUpdate() {
    this._update(this._wrapper._gsTransform.x);
  }

  _onDragStart() {
    this._wrapper.style.touchAction = 'none';
    this._removeActive();
    this._drag = true;
  }
  _onPress() {
    this._wrapper.style.cursor = grabbing;
  }
  _onPressRubber(e) {
    this._wrapper.style.cursor = grabbing;

    let curr = Math.floor((e.clientX - this._draggable.x) / this._slideWidth);
    let slides = this._slides;

    this._updateParams.slidesBefore = slides.slice(0, curr).reverse();
    this._updateParams.slidesAfter = slides.slice(curr);
  }
  _onRelease() {
    this._wrapper.style.touchAction = 'pan-y';
    this._drag = false;
  }
  _onReleaseCursor() {
    this._wrapper.style.touchAction = 'pan-y';
    this._drag = false;
    this._wrapper.style.cursor = grab;
  }
  // _onThrowComplete() {
  //   this._slidesActiveStartOld = this._slidesActiveStart;
  //   this._slidesActiveStart = Math.abs(Math.round(this._draggable.endX / this._slideWidth));
  //
  //   this._setActive()
  // }
  _onDragEnd() {
    this._slidesActiveStartOld = this._slidesActiveStart;
    this._slidesActiveStart = Math.abs(Math.round(this._draggable.endX / this._slideWidth));

    this._setActive()
  }
  _onDragUpdate(e) {
    e.preventDefault();
    this._updateParams.newX = this._draggable.x;

    this._onUpdate();
  }
  _onRubberUpdate() {
    this._updateParams.newX = this._wrapper._gsTransform.x;

    this._onUpdate();
  }
  _animatron() {
    let params = this._updateParams;

    params.lastX = params.currentX;

    params.moveX += (params.newX - params.moveX) / 40;

    params.currentX += (params.newX - params.currentX) / 20;

    params.speed = params.lastX - params.currentX;

    params.smooth += params.speed / 5;
    params.smooth /= 2;
    params.smooth = Math.max(params.smooth, -25);
    params.smooth = Math.min(params.smooth, 25);

    // console.log(params.smooth)

    if (params.smooth < 0.001 && params.smooth > -0.001) {
      params.smooth = 0;
    }
    this._updateSlides(params.smooth);

    params.raf = requestAnimationFrame(this.animatron);
  }

  _updateSlides(smooth) {
    if (smooth === this._updateParams.lastSmooth) return;
    this._updateParams.lastSmooth = smooth;

    let b = this._updateParams.slidesBefore;
    let a = this._updateParams.slidesAfter;

    let bPlus = this._rubber;
    for (let i = 0; b.length > i; i++) {
      b[i].style.transform = `translate3d(${smooth * bPlus}px, 0, 0)`;

      bPlus += this._rubber;
    }

    let aPlus = this._rubber;
    for (let i = 0; a.length > i; i++) {
      a[i].style.transform = `translate3d(${smooth * aPlus}px, 0, 0)`;

      aPlus += this._rubber;
    }
  }
}

window.customElements.define('view-slider', Slider);
